import { ChangeProjectPart } from './../../project.model';
import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup, Validators } from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { DictionaryEntry } from '@sdbn/common';
import { TranslationService } from '@sdbn/common';
import { HttpService } from '@sdbn/appclient';
import { environment } from 'src/environments/environment';
import { AddProjectPart } from '../../project.model';

@Component({
  selector: 'app-change-project-part-dialog',
  templateUrl: './change-project-part-dialog.component.html',
  styleUrls: ['./change-project-part-dialog.component.scss']
})
export class ChangeProjectPartDialogComponent implements OnInit {

  name: string;

  formGroup = new FormGroup({});

  confirmDisabled = false;

  projectId: number;
  projectPartId: number;

  constructor(
    public translationService: TranslationService,
    public dialogRef: MatDialogRef<ChangeProjectPartDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private http: HttpService
  ) {

    this.projectId = data.projectId;
    this.projectPartId = data.projectPartId;
    this.name = data.name;

    this.formGroup.addControl('name', new FormControl(this.name, [Validators.required]));


  }

  ngOnInit(): void {

    this.formGroup.valueChanges.subscribe(formValues => {
      this.name = formValues.name;
    });

    this.formGroup.statusChanges.subscribe(newStatus => {
      this.confirmDisabled = !this.formGroup.valid;
    });

    this.confirmDisabled = !this.formGroup.valid;
    this.formGroup.markAllAsTouched();

  }

  onClose() {
    this.dialogRef.close();
  }

  onConfirm() {
    this.http.postWithContext<number>(environment.erpProjectEndpoint + '/changeProjectPart',
      new ChangeProjectPart({ projectId: this.projectId, projectPartId: this.projectPartId, name: this.name }))
      .subscribe(response => {

        console.log('response is', response);

        this.dialogRef.close();

      }, error => {
        console.log('error is', error);
      });
  }

}
